import { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { round2 } from '../lib/api';
import { GradeBadge } from './SellerScorecard';

export default function AdminScorecards() {
  const [data, setData] = useState(null);
  const [q, setQ] = useState('');
  useEffect(() => { round2.adminScorecards().then(setData).catch(() => setData({ items: [] })); }, []);
  if (!data) return <Loader2 className="w-6 h-6 animate-spin text-[#E67E22] mt-6"/>;
  const rows = data.items.filter(s => !q || (s.store_name || '').toLowerCase().includes(q.toLowerCase()));
  return (
    <section data-testid="admin-scorecards" className="mt-6 space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="font-heading font-bold text-xl">Seller Scorecards <span className="text-sm font-normal text-ink/60">· lowest first</span></div>
        <input data-testid="admin-scorecards-search" value={q} onChange={e => setQ(e.target.value)} placeholder="Search shop" className="rounded-full border border-border px-4 py-2 text-sm"/>
      </div>
      <div className="card-soft overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wider text-ink/60">
            <tr><th className="p-3">Grade</th><th className="p-3">Shop</th><th className="p-3">Score</th><th className="p-3">Rating</th><th className="p-3">Completed</th><th className="p-3">Within a day</th><th className="p-3">Complaints</th><th className="p-3">Orders</th></tr>
          </thead>
          <tbody>
            {rows.map(s => (
              <tr key={s.store_id} data-testid={`admin-scorecard-row-${s.store_id}`} className="border-t border-border">
                <td className="p-3"><GradeBadge grade={s.grade} score={s.score}/></td>
                <td className="p-3 font-semibold">{s.store_name}<div className="text-xs text-ink/50">{s.village}</div></td>
                <td className="p-3">{s.score}</td>
                <td className="p-3">{s.metrics.rating_avg || '—'}</td>
                <td className="p-3">{s.metrics.delivered_pct}%</td>
                <td className="p-3">{s.metrics.avg_delivery_hours == null ? '—' : `${s.metrics.on_time_pct}%`}</td>
                <td className="p-3">{s.metrics.complaints}</td>
                <td className="p-3">{s.metrics.orders}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
